export function footer() {
	function footerdown() {
		const footer = document.querySelector('footer').offsetHeight;
		const windowHeight = window.innerHeight;
		const contentMinHeight = windowHeight - footer;
		document.querySelector('main').style.minHeight = `${contentMinHeight}px`;
	}

	function bindCookieSettingsButtons() {
		const cookieButtons = document.querySelectorAll('.js-cookie-button');
		if (!cookieButtons.length) {
			return;
		}

		cookieButtons.forEach((button) => {
			button.addEventListener('click', (event) => {
				event.preventDefault();

				if (window.Cookiebot && typeof window.Cookiebot.renew === 'function') {
					window.Cookiebot.renew();
					return;
				}

				if (window.CookieFirst && typeof window.CookieFirst.openPanel === 'function') {
					window.CookieFirst.openPanel();
					return;
				}

				if (window.CookieConsent && typeof window.CookieConsent.renew === 'function') {
					window.CookieConsent.renew();
				}
			});
		});
	}

	footerdown();
	bindCookieSettingsButtons();

	window.addEventListener('resize', footerdown);
}
